import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
import $ from 'jquery';
import HashLoader from "react-spinners/HashLoader";
import number_format from "../../../../components/Constants/NumberFormat";

import moment from "moment";
import PostLoginGetApi from "../../../../components/Api/PostLoginGetApi";
import PostLoginPostApi from "../../../../components/Api/PostLoginPostApi";
import Button from "../../../../components/Button";
import init from "../../AccessControl/Check";
import { MAX_UPLOAD_FILE_SIZE } from "../../../../components/Constants/FileUpload";
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";
import { SUPER_ADMIN_CODE } from "../../ConstRole/ConstRole";

import ExampleCustomCodeTemplate from './../../../../sample-csv/custom-code-template.xlsx';

const EditOffer = () => {
    const pageName = "Voucher Offer Update";
    const isAccess = init(pageName);

    const userProfile = useContext(UserBasicInfoContext);

    const navigate = useNavigate();
    const { state } = useLocation();


    const [totalQuantity, setTotalQuantity] = useState("");

    const [isCode, setIsCode] = useState(0);




    const fileInput = useRef();
    const [file, setFile] = useState();


    const [input, setInput] = useState({
        name: "",
        logo: "",
        amount: "",
        purchase_price: "",
        brand_id: "",
        offer_quantity: "",
        validity_start_date: "",
        validity_end_date: "",
        sku: "",
        terms: "",
        redeem_type: "",
        redeem_period: "",
        redeem_start_date: "",
        redeem_end_date: ""
    });


    const [isStart, setIsStart] = useState(false);
    const [redeemEndMinDate, setRedeemEndMinDate] = useState(state?.data?.redeem_start_date ?? new Date());
    useEffect(() => {
        if (state === null || state?.data === undefined || state?.data === "" || state?.data === null) {
            toast.error("No valid information found.");
            return navigate(-1);
        }


        let is_start = (moment(state?.data?.validity_start_date, 'YYYY-MM-DD').valueOf() <= moment(new Date(), 'YYYY-MM-DD').valueOf());
        if( userProfile?.user_type_id !== SUPER_ADMIN_CODE && is_start ) {
            toast.error("You are not allowed to edit this offer !");
            return navigate(-1);
        }

        if(state?.data?.is_publish === 2) {
            is_start = true;
        }

        setIsStart(is_start);
        setIsCode(state?.data?.is_custom_code);

        setInput({
            ...input,
            name: state?.data?.name,
            logo: state?.data?.logo,
            amount: state?.data?.amount,
            commission: state?.data?.commission,
            commission_type: state?.data?.commission_type,
            brand_id: state?.data?.brand_id,
            validity_start_date: state?.data?.validity_start_date,
            validity_end_date: state?.data?.validity_end_date,
            sku: state?.data?.sku,
            terms: state?.data?.terms,
            redeem_type: state?.data?.redeem_type ?? "",
            redeem_period: state?.data?.redeem_period ?? "",
            redeem_start_date: state?.data?.redeem_start_date ?? "",
            redeem_end_date: state?.data?.redeem_end_date ?? ""
        });


        setTimeout(()=>{
            $("#sell_price_span").html(number_format(state?.data?.purchase_price, 2));
            $("#sell_price_span2").html(number_format(state?.data?.purchase_price, 2));
        },1000);


        if( state?.data?.redeem_start_date < state?.data?.validity_end_date ) {
            setRedeemEndMinDate(state?.data?.validity_end_date);
        }

    }, [state]);


    const selectFile = () => {
        fileInput.current.click();
    }

    const cancelFile = () => {
        setFile();
        fileInput.current.value = "";
    }

    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        } 

        

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile(e.target.files[0]);
    }


    const fileInput2 = useRef();
    const [file2, setFile2] = useState();

    const selectFile2 = () => {
        fileInput2.current.click();
    }

    
    const handleChange2 = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("application/vnd.")) {
            toast.error("Please upload valid excel");
            return;
        }

        setFile2(e.target.files[0]);
    }


    const [brandList, setBrandList] = useState([]);

    useEffect(() => {

        // Voucher Brand List
        PostLoginGetApi("voucher/brand", "", 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBrandList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, []);


    const [loading, setLoading] = useState(false);
    const submitFormData = (event) => {
        event.preventDefault();


        const id = state?.data?.id;
        if (isNaN(id)) {
            toast.error("No valid id found.");
            navigate(-1);
        }


        let requestBody = new FormData();
        requestBody.append("name", input.name);
        requestBody.append("amount", input.amount);
        requestBody.append("purchase_price", setSellPrice());
        requestBody.append("brand_id", input.brand_id);

        requestBody.append("commission", input.commission);
        requestBody.append("commission_type", $("input[type='radio'][name='discount_type']:checked").val() ?? input.commission_type);

        requestBody.append("validity_start_date", input.validity_start_date);
        requestBody.append("validity_end_date", input.validity_end_date);
        
        let redeem_type = input.redeem_type;
        requestBody.append("redeem_type", redeem_type);
        if (redeem_type === 'days') {
            requestBody.append("redeem_start_date", "");
            requestBody.append("redeem_end_date", "");
            requestBody.append("redeem_period", input.redeem_period);
        }
        else if(redeem_type === "dates") {
            if( input.redeem_end_date < input.validity_end_date ) {
                toast.error("Redeem end date must be greater than or equal to selling end date.");
                $("#redeem_end_date").focus();
                return;
            }

            requestBody.append("redeem_period","");
            requestBody.append("redeem_start_date", input.redeem_start_date);
            requestBody.append("redeem_end_date", input.redeem_end_date);

        }
        else {
            toast.error("Invalid Redeem Type !");
            return;
        }



        requestBody.append("sku", input.sku);
        requestBody.append("terms", input.terms);


        if (file !== undefined && file !== null && file !== "") {
            requestBody.append("logo", file);
        }


        setLoading(true);
        PostLoginPostApi("voucher/offer/update/" + id, requestBody, 1, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {

                    let tabLink = "requested-offer";
                    if( state?.data?.is_publish === 2 ) {
                        tabLink = "offer";
                    }
                    toast.success(responseData["messages"].toString());
                    return navigate("/dashboard/voucher", {
                        state: {
                            tab: tabLink
                        }
                    });

                }

                
                setTimeout(()=>{

                    $("#sell_price_span").html(number_format(requestBody.get("purchase_price"), 2));
                    $("#sell_price_span2").html(number_format(requestBody.get("purchase_price"), 2));
                    
                },1000);

                toast.error(responseData["messages"].toString());

            }
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        }).finally(() => {
            setLoading(false);
            return;
        });
    }


    
    const handleInputChange = (evt) => {
        const value = evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;

        if (evt.target.name === "redeem_period" || evt.target.name === "amount" || evt.target.name === "commission" || evt.target.name === "offer_quantity") {
            if (isNaN(value)) {
                return;
            }

            if(value.toString().includes(".")) {
                return;
            }
        }


        if (evt.target.name === "validity_start_date") {
            setInput({ ...input, validity_start_date: value, validity_end_date: "", redeem_start_date: "", redeem_end_date: ""});
            return;
        }

        if (evt.target.name === "validity_end_date") {
            setInput({ ...input, validity_end_date: value, redeem_start_date: "", redeem_end_date: ""});
            setRedeemEndMinDate(value);
            return;
        }

        if (evt.target.name === "redeem_start_date") {
            setInput({ ...input, redeem_start_date: value, redeem_end_date: ""});
            if( $("#validity_end_date").val() > value ) {
                setRedeemEndMinDate($("#validity_end_date").val());
            }
            else {
                setRedeemEndMinDate(value);
            }
            return;
        }


        // Handle Commission
        if( evt.target.name === "commission" ) {
            const re = /^[0-9]*(\.[0-9]{0,2})?$/;
            const ct = $("input[type='radio'][name='discount_type']:checked").val();
            if( ct === 'percentage' ) {
                if(value > 100) {
                    return;
                }
            }
            else {
                if( parseFloat(value) > parseFloat(input.amount) ) {
                    return;
                }
            }

            if( !re.test(value) ) {
                return;
            }
        }

        
        setInput({ ...input, [evt.target.name]: value });
    }



    const setSellPrice = () => {
        const type = $("input[type='radio'][name='discount_type']:checked").val() ?? input.commission_type;
        const amount = parseFloat($("#amount").val() ?? 0);
        const discount = parseFloat($("#commission").val() ?? 0);
        
        let sell_price = amount;
        
        if(discount > 0) {
            if( type === 'percentage') {
                sell_price = amount - ((amount * discount) / 100);
            }
            else {
                sell_price = amount - discount;
            }
        }

        if(isNaN(sell_price) ) {
            sell_price = 0;
        }

        if( sell_price < 0 ) {
            return sell_price;
        }
        
        sell_price = parseFloat(sell_price);
        $("#sell_price_span").html(number_format(sell_price, 2));
        $("#sell_price_span2").html(number_format(sell_price, 2));
        
        if( isStart === true ) {
            return state.data?.purchase_price ?? 0;
        }
        return sell_price;
    }

    const setCommissionEmpty = () => {
        $("#commission").val("");
        if($("input[type='radio'][name='discount_type']:checked").val() === input.commission_type) {
            $("#commission").val(input.commission);
        }

        setSellPrice();
    }


    const [updateQuantity, setUpdateQuantity] = useState("");
    const quantityChangeHandler = (value) => {
        if (isNaN(value)) {
            return;
        }

        if (value.includes(".")) {
            return;
        }

        if(parseInt(value) > 999) {
            return;
        }

        setUpdateQuantity(value);
    }


    const submitUpdateQuantity = (event) => {
        // eslint-disable-next-line no-restricted-globals
        if(!confirm('Are you sure want to update quantity ?')) {
            return;
        }
        
        event.preventDefault();
        const id = state?.data?.id;
        if (isNaN(id)) {
            toast.error("No valid id found.");
            navigate(-1);
        }


        let requestBody = new FormData();
        if( isCode === 0 ) {
            if (updateQuantity === 0 || updateQuantity === "" || updateQuantity === null || updateQuantity === undefined) {
                return;
            }

            requestBody.append("offer_quantity", updateQuantity);
        }
        else {
            if(file2 === undefined) {
                toast.error("Please upload a valid code csv file");
                return;
            }

            requestBody.append("offer_quantity", 0);
            requestBody.append("custom_code_excel", file2);
        }




        setLoading(true);
        PostLoginPostApi("voucher/offer/update/quantity/" + id, requestBody, 1, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setTotalQuantity(responseData["messages"]["quantity"] ?? "");
                    setUpdateQuantity("");
                    setFile2();
                    toast.success(responseData["messages"]["message"].toString() ?? "Voucher offer quantity added successfully !.");
                    return;
                }

                toast.error(responseData["messages"].toString());
                return;
            }
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        }).finally(()=>{
            setLoading(false);
            
            setTimeout(()=>{
                $("#sell_price_span").html(number_format(state?.data?.purchase_price, 2));
                $("#sell_price_span2").html(number_format(state?.data?.purchase_price, 2));
            },1000);
        });
    }


    useEffect(()=>{
        const id = state?.data?.id;
        if (isNaN(id)) {
            return;
        }

        PostLoginGetApi("voucher/offer/view/quantity/" + id , {}, 2).then((responseJSON)=> {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setTotalQuantity(responseData.data?.quantity ?? 0);
                    return;
                }


                toast.error(responseData.messages ?? "A problem occur. Please try again.");
                navigate(-1);
            }

        }).catch((err)=>{
            console.log(err);
        });

    },[navigate, state?.data?.id]);



    const setRedeemType = () => {

        $("#redeem_period_days_div").hide();
        $("#redeem_period_dates_div").hide();
        $("#redeem_period").attr("required", false);
        $("#redeem_start_date").attr("required", false);
        $("#redeem_end_date").attr("required", false);

        
        let val = $("input[type='radio'][name='redeem_type']:checked").val() ?? null;
        if( val === 'days' ) {
            $("#redeem_period_days_div").show();
            $("#redeem_period").focus();
            $("#redeem_period").attr("required", true);
        }
        else if( val === 'dates' ) {
            $("#redeem_period_dates_div").show();
            $("#redeem_start_date").focus();
            $("#redeem_start_date").attr("required", true);
            $("#redeem_end_date").attr("required", true);
        }
        

        setInput({...input, 
            redeem_type: val, 
            redeem_period: input.redeem_period ?? "", 
            redeem_start_date: input.redeem_start_date ?? "", 
            redeem_end_date: input.redeem_end_date ?? ""});
    }



    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className='flex justify-center items-center w-full h-screen'>
            {loading ?
                <HashLoader
                    color={"#1882FF"}
                    loading={loading}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                /> :
            <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
                <div className="font-medium pb-[60px]">
                    <header className="flex justify-between items-center p-4 border-b-2 border-dark-white mb-[60px]">
                        <Link to="/dashboard/voucher" state={{ tab: "offer" }}><CloseBtn /></Link>
                        <p className="text-xl text-black m-auto">Edit Voucher Offer</p>
                    </header>
                    <main className="max-w-3xl m-auto">
                        <div className="flex justify-center ">
                            <form action='' autoComplete="off" method='POST' className="w-full" onSubmit={(event) => submitFormData(event)} >

                                <div className="relative pb-2 pt-1 mb-1">
                                    <input type="text" name="name" id="name" value={input.name} onChange={handleInputChange} title="name" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                    <label htmlFor="name" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Offer Title *</label>
                                </div>

                                <div className="flex pb-2 pt-1 mb-2 items-center">
                                    <div className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                                        <input type="file" className="hidden" name="logo" ref={fileInput} onChange={handleChange} />
                                        <label htmlFor="Trade License" className="p-1 text-base font-medium">Offer Banner *</label>
                                        {file ?
                                            <>
                                                <img src={URL.createObjectURL(file)} alt="Preview Logo" className="max-h-10 max-w-10 ml-auto order-3" />
                                                <p style={{ fontSize: "10px" }} onClick={() => cancelFile()} className="text-red-700 font-semibold cursor-pointer">cancel</p>
                                                <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[50px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change</button>
                                            </> :
                                            <>
                                                <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify text-sm" onClick={selectFile}>Update Offer Banner</button>
                                            </>
                                        }

                                    </div>

                                    <div className="relative w-[49.5%] p-2 rounded-md ml-auto">
                                        <img src={state.data?.logo} alt="Current Logo" className="float-left max-h-10 max-w-10 ml-auto order-3" />
                                    </div>
                                </div>




                                <div className="relative py-2 mb-1">
                                    <input type="text" name="amount" id="amount" readOnly={isStart} value={input.amount} onChange={(e) => {handleInputChange(e); setSellPrice();}} maxLength={7} title="Amount" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                    <label htmlFor="amount" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Face Value *</label>
                                </div>
                            


                                <div className="flex w-full mt-2">
                                    { isStart === false ?  <>
                                    <div className="relative py-2 mb-1 w-2/3">
                                    <input type="text" name="commission" id="commission" readOnly={isStart} value={input.commission} onChange={(e) => {handleInputChange(e); setSellPrice();}} title="" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer -z-50" required />

                                    <label htmlFor="commission" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Discount *</label>


                                    {(state.data?.commission_type === "percentage") ? 
                                    <ul className="items-center float-right -mt-[44px] w-[120px] text-sm font-medium text-gray-900 bg-white rounded-lg  sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white z-50">
                                        <label htmlFor="discount_type_1" className="flex items-center w-full z-10 ">
                                            <input type="radio" name="discount_type" id="discount_type_1" onChange={setCommissionEmpty} value="percentage" defaultChecked />
                                            <span></span>
                                            <span className="py-2 text-lg inline-block">%</span>
                                        </label>

                                        <label htmlFor="discount_type_2" className="flex items-center w-full z-10 ">
                                            <input type="radio" name="discount_type" id="discount_type_2" onChange={setCommissionEmpty} value="fixed" />
                                            <span></span>
                                            <span className="py-2 pt-3 text-sm inline-block">{process.env.REACT_APP_CURRENCY_SYMBOL}</span>
                                        </label>
                                    </ul>
                                    :
                                    <ul className="items-center float-right -mt-[44px] w-[120px] text-sm font-medium text-gray-900 bg-white rounded-lg  sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white z-50">
                                        <label htmlFor="discount_type_1" className="flex items-center w-full z-10 ">
                                            <input type="radio" name="discount_type" id="discount_type_1" onChange={setCommissionEmpty} value="percentage" />
                                            <span></span>
                                            <span className="py-2 text-lg inline-block">%</span>
                                        </label>

                                        <label htmlFor="discount_type_2" className="flex items-center w-full z-10 ">
                                            <input type="radio" name="discount_type" id="discount_type_2" onChange={setCommissionEmpty} value="fixed" defaultChecked />
                                            <span></span>
                                            <span className="py-2 pt-3 text-sm inline-block">{process.env.REACT_APP_CURRENCY_SYMBOL}</span>
                                        </label>
                                    </ul>
                                    }
                                    
                                    </div>
                                    <div className="relative py-2 w-1/3 mt-2.5 pl-4 text-right">
                                        Sell Price : <span className="font-semibold" id="sell_price_span"></span>
                                    </div>
                                    </>
                                    :

                                    
                                    <div className="flex pb-2 w-full pl-0">
                                        
                                        <div className="relative py-2 mb-1 w-1/2">
                                            <input type="text" name="commission" id="commission" value={input.commission} title="" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer -z-50" required />

                                            <label htmlFor="commission" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Discount *</label>
                                            <ul className="items-center float-right -mt-[44px] w-[120px] text-sm font-medium text-gray-900 bg-white rounded-lg  sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white z-50">
                                                
                                                
                                                {(state.data?.commission_type === "percentage") ? 
                                                <>
                                                <label htmlFor="discount_type_1" className="flex items-center w-full z-10 ">
                                                    <input type="radio"  disabled checked />
                                                    <span></span>
                                                    <span className="py-2 text-lg inline-block">%</span>
                                                </label>

                                                <label htmlFor="discount_type_2" className="flex items-center w-full z-10 ">
                                                    <input type="radio" disabled />
                                                    <span></span>
                                                    <span className="py-2 pt-3 text-sm inline-block">{process.env.REACT_APP_CURRENCY_SYMBOL}</span>
                                                </label>
                                                </>
                                                :
                                                <>
                                                    <label htmlFor="discount_type_1" className="flex items-center w-full z-10 ">
                                                        <input type="radio"  disabled />
                                                        <span></span>
                                                        <span className="py-2 text-lg inline-block">%</span>
                                                    </label>

                                                    <label htmlFor="discount_type_2" className="flex items-center w-full z-10 ">
                                                        <input type="radio" disabled checked />
                                                        <span></span>
                                                        <span className="py-2 pt-3 text-sm inline-block">{process.env.REACT_APP_CURRENCY_SYMBOL}</span>
                                                    </label>
                                                </>
                                                }
                                            </ul>
                                        </div>
                                        
                                        <span className="w-1/2 float-right text-right pt-4">Sell Price({process.env.REACT_APP_CURRENCY_SYMBOL}) : <span className="font-semibold" id="sell_price_span2"></span></span>

                                    </div>
                                    }
                                    
                                </div>

                                {/* {(isStart === true) &&
                                <div className="relative py-2 mb-1">
                                    <input type="text" name="purchase_price" id="purchase_price" value={input.purchase_price} onChange={handleInputChange} title="Amount" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                    <label htmlFor="purchase_price" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Sell Price *</label>
                                </div>
                                } */}


                                <div className="relative py-2 mb-1">
                                    <select name="brand_id" id="brand_id" value={input.brand_id} onChange={handleInputChange} className="w-full rounded border-solid border border-dark-white " required>
                                        <option value="" hidden>Select brand *</option>
                                        {brandList.map((data, index) => (
                                            <option key={index} value={data.id} className='text-black'>{data.name}</option>
                                        ))}
                                    </select>
                                </div>



                                <div className="relative border-zinc-200 border py-1 px-3 my-3 rounded-md">
                                    <div className="flex py-2 mb-2">
                                        <div className="flex w-auto mt-1 h-[42px] bg-white items-center border border-gray-100 rounded-md">
                                            <p className="text-[16px] ml-2 font-semibold">
                                                Voucher Code Type 
                                            </p>

                                            <span className="flex ml-4 mr-2">
                                                {isCode === 0 ? 
                                                <label htmlFor="auto_generated_code" className="flex items-center z-10 w-auto px-3 cursor-pointer">
                                                    <input type="radio" name="code_type" id="auto_generated_code" value="0" checked />
                                                    <span></span>
                                                    <span className="py-2 text-md inline-block w-max">Auto Generated</span>
                                                </label>
                                                :
                                                <label htmlFor="custom_code" className="flex items-center w-full z-10 cursor-pointer">
                                                    <input type="radio" name="code_type" id="custom_code" value="1" checked />
                                                    <span></span>
                                                    <span className="py-2 text-md inline-block">Custom</span>
                                                </label>
                                                }
                                            </span>
                                        </div>
                                        <span className="pl-4 pt-3">Current Quantity : <span className="text-right font-semibold">{totalQuantity}</span></span>
                                    </div>

                                    
                                    {isCode === 0 ? 
                                    <div className="flex w-full" id="quantity_div">
                                        <div className="relative py-2 mb-3 w-1/3">
                                            <input type="text" name="offer_quantity" id="offer_quantity" value={updateQuantity} onChange={(event) => quantityChangeHandler(event.currentTarget.value)} pattern="[0-9]*" maxLength={3} title="Offer Quantity" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                            <label htmlFor="offer_quantity" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Offer Quantity *</label>
                                        </div>
                                    </div>
                                    :
                                    <div className="flex items-center align-middle mt-2 mb-4" id="excel_div">
                                        <h1 className="text-base font-semibold pl-1 pr-4 w-[200px]">
                                            Code CSV *
                                            <Link to={ExampleCustomCodeTemplate} download="Example-custom-code-template" target="_blank" rel="noreferrer" className='text-xs font-normal block -mt-1'>Download Sample</Link>
                                        </h1>
                                        <div className="flex relative w-full bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0", marginLeft: "55px" }}>
                                            <input type="file" name="code_csv" id="code_csv" className="hidden" ref={fileInput2} onChange={handleChange2} />

                                            {file2 ?
                                                <>
                                                    <span className='text-sm pt-[6px]' title={file2.name}>
                                                        {file2.name.toString().substring(0, 28)}
                                                        {(file2.name.length > 28) && <>...</>}
                                                    </span>
                                                    <button type="button" className="text-white ml-auto float-right order-3 bg-[#444] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile2}>Change</button>
                                                </> :
                                                <>
                                                    <label htmlFor="logo" className="p-1 pt-[5px] text-base font-medium">Upload Code CSV</label>
                                                    <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-sm" onClick={selectFile2}>Upload</button>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    }


                                    <div className="relative mb-3">
                                        <button type="button" onClick={submitUpdateQuantity} className=" py-2 px-4 rounded-md border border-transparent font-semibold bg-gray-800 text-white hover:bg-gray-900  transition-all text-sm">
                                            Update Quantity
                                        </button>
                                    </div>


                                </div>


                                


                                <div className="pt-0 pb-1 flex justify-between">
                                    <div className="relative py-2 mb-1 w-1/2 mr-5">
                                        <input type="date" name="validity_start_date" id="validity_start_date" value={input.validity_start_date} min={moment().format("YYYY-MM-DD")} onChange={handleInputChange} title="Start Date" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                        <label htmlFor="validity_start_date" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Selling Start Date *</label>
                                    </div>

                                    <div className="relative py-2 mb-1 w-1/2">
                                        <input type="date" name="validity_end_date" id="validity_end_date" value={input.validity_end_date} min={moment(input.validity_start_date).format("YYYY-MM-DD")} onChange={handleInputChange} title="Brand Id" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />
                                        <label htmlFor="validity_end_date" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Selling End Date *</label>
                                    </div>
                                </div>



                                <div className="flex py-2 ">

                                    <div className="flex w-auto mt-1 h-[42px] bg-white items-center border border-gray-100 rounded-md">
                                        
                                        <p className="text-[16px] ml-2 font-semibold">
                                            Redeem Type
                                        </p>

                                        
                                        {(input.redeem_type === "days") ?
                                            <span className="flex ml-4 mr-2">
                                                <label htmlFor="redeem_days" className="flex items-center z-10 w-auto px-3 cursor-pointer">
                                                    <input type="radio" name="redeem_type" id="redeem_days" onClick={setRedeemType} value="days" defaultChecked />
                                                    <span></span>
                                                    <span className="py-2 text-md inline-block">Days</span>
                                                </label>

                                                <label htmlFor="redeem_dates" className="flex items-center w-full z-10 cursor-pointer">
                                                    <input type="radio" name="redeem_type" id="redeem_dates" onClick={setRedeemType} value="dates" />
                                                    <span></span>
                                                    <span className="py-2 text-md inline-block">Date Range</span>
                                                </label>
                                            </span>
                                            :
                                            <span className="flex ml-4 mr-2">
                                                <label htmlFor="redeem_days" className="flex items-center z-10 w-auto px-3 cursor-pointer">
                                                    <input type="radio" name="redeem_type" id="redeem_days" onClick={setRedeemType} value="days"  />
                                                    <span></span>
                                                    <span className="py-2 text-md inline-block">Days</span>
                                                </label>

                                                <label htmlFor="redeem_dates" className="flex items-center w-full z-10 cursor-pointer">
                                                    <input type="radio" name="redeem_type" id="redeem_dates" onClick={setRedeemType} value="dates" defaultChecked />
                                                    <span></span>
                                                    <span className="py-2 text-md inline-block">Date Range</span>
                                                </label>
                                            </span>
                                        }

                                    </div>

                                </div>
                                
                                {(input.redeem_type === "days") && 
                                    <div className="relative mt-3 pt-1 pb-2 mb-3" id="redeem_period_days_div">
                                        <input type="text" name="redeem_period" id="redeem_period" value={input.redeem_period} onChange={handleInputChange} title="Redeem Period in Days" placeholder=" " pattern="[0-9]*" maxLength={5} className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                        <label htmlFor="redeem_period" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Redeem Period (After Purchase) *</label>
                                    </div>
                                }


                                {(input.redeem_type === "dates") && 
                                <div className="flex justify-between mt-3 pt-1 pb-2 mb-3" id="redeem_period_dates_div">
                                    <div className="relative w-1/2 mr-5">
                                        <input type="date" name="redeem_start_date" id="redeem_start_date" value={input.redeem_start_date} min={moment(input.validity_start_date).format("YYYY-MM-DD")} onChange={handleInputChange} title="Redeem Start Date" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                        <label htmlFor="redeem_start_date" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Redeem Start Date *</label>
                                    </div>


                                    <div className="relative w-1/2">
                                        <input type="date" name="redeem_end_date" id="redeem_end_date" value={input.redeem_end_date} 
                                        min={moment(redeemEndMinDate).format("YYYY-MM-DD")} onChange={handleInputChange} title="Redeem End Date" placeholder=" " 
                                        className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                        <label htmlFor="validity_end_date" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Redeem End Date *</label>
                                    </div>
                                </div>
                                }

                                <div className="relative pb-1 pt-1 mt-2">
                                    <input type="text" name="sku" id="sku" value={input.sku} onChange={handleInputChange} placeholder=" " className="text-md w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                    <label htmlFor="sku" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">SKU / Plan Code / Other Identity</label>
                                </div>

                                
                                <div className="relative pb-2 mt-5 mb-4">
                                    <textarea name="terms" id="terms" value={input.terms} onChange={handleInputChange} title="Terms and Conditions" placeholder=" " className="w-full h-32 rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer resize-none"></textarea>

                                    <label htmlFor="terms" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-2 scale-75 top-0 z-10 origin-[0] -mt-1 bg-white dark:bg-gray-900 px-2 peer-focus:-mt-3 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-2 left-1">Terms and Conditions</label>
                                </div>



                                <Button name="Update Voucher Offer"></Button>
                            </form>
                        </div>
                    </main>
                </div>

                <style>{`
                    * :disabled {
                        background-color: #F5F5F5 !important;
                    }

                    label > input[type='radio'], input[type="radio"] {
                        display: none;
                    }

                    label > input[type="radio"] + *::before {
                        color: #158560 !important;
                        content: " ";
                        display: inline-grid;
                        width: 1.1rem;
                        height: 1.1rem;
                        border-radius: 50%;
                        border-style: solid;
                        border-width: 0.1rem;
                        border-color: #158560;
                        margin-top: 5px;
                    }

                    label > input[type="radio"]:checked + *::before {
                        background: radial-gradient(#158560 0%, #158560 40%, transparent 50%, transparent);;
                        border-color: #158560;
                    }

                    label > input[type="radio"] + * {
                        display: inline-block;
                        padding: 0.5rem;
                    }


                `}</style>

            </div>}
        </div>
    );
};

export default EditOffer;